import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
   GhostOnDarkButton,
   PrimaryOnDarkButton,
} from '../../../styles/ui/Button';
import { AMBER } from '../styles';

// ---------------------------------------------------------------------------
// Barra de salvamento fixa — só monta quando há alterações pendentes.
// Botões do kit on-dark (FC7 G.2): Salvar = PrimaryOnDarkButton (escrita em
// superfície escura, variante promovida nesta entrega); Descartar = ghost.
// z-index 30 fica abaixo do ToastContainer (99999) de propósito.
// ---------------------------------------------------------------------------

const Bar = styled.div`
   position: fixed;
   left: 0;
   right: 0;
   bottom: 0;
   z-index: 30;
   background: #2e2e2e;
   border-top: 1px solid rgba(255, 255, 255, 0.12);
   padding: 12px 24px;
   display: flex;
   align-items: center;
   justify-content: space-between;
   gap: 16px;
`;

const Status = styled.div`
   display: flex;
   align-items: center;
   gap: 10px;
   font-size: 13px;
   color: ${({ theme }) => theme.colors.textOnAppBackground};

   strong {
      color: #fff;
   }
`;

const Dot = styled.span`
   width: 8px;
   height: 8px;
   border-radius: 999px;
   background: ${AMBER.base};
   flex: 0 0 auto;
`;

const Actions = styled.div`
   display: flex;
   align-items: center;
   gap: 10px;
`;

// Link-botão "Ver alterações" (v2 do handoff) — abre o modal de diff a partir
// da barra. Botão local em superfície escura; o hover declara background e
// text-decoration (G.4.1).
const ViewChangesLink = styled.button`
   appearance: none;
   border: 0;
   background: transparent;
   font-family: inherit;
   cursor: pointer;
   padding: 0;
   font-size: 13px;
   font-weight: 700;
   color: ${({ theme }) => theme.colors.primarySoft};
   text-decoration: none;

   &:hover:not(:disabled) {
      background: transparent;
      color: ${({ theme }) => theme.colors.primarySoftHover};
      text-decoration: underline;
   }
   &:focus-visible {
      outline: none;
      box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.focusRing};
   }
`;

export default function SaveBar({ count, saving, onDiscard, onSave, onViewChanges }) {
   if (count === 0) return null;
   return (
      <Bar>
         <Status>
            <Dot />
            <span>
               <strong>{count}</strong>{' '}
               {count === 1 ? 'alteração não salva' : 'alterações não salvas'}
            </span>
            <ViewChangesLink type="button" onClick={onViewChanges}>
               Ver alterações
            </ViewChangesLink>
         </Status>
         <Actions>
            <GhostOnDarkButton type="button" onClick={onDiscard} disabled={saving}>
               Descartar
            </GhostOnDarkButton>
            <PrimaryOnDarkButton type="button" onClick={onSave} disabled={saving}>
               {saving ? 'Salvando...' : 'Salvar permissões'}
            </PrimaryOnDarkButton>
         </Actions>
      </Bar>
   );
}

SaveBar.propTypes = {
   count: PropTypes.number.isRequired,
   saving: PropTypes.bool,
   onDiscard: PropTypes.func.isRequired,
   onSave: PropTypes.func.isRequired,
   onViewChanges: PropTypes.func.isRequired,
};

SaveBar.defaultProps = {
   saving: false,
};
